export enum PUBLIC_ROUTES {
  MAIN_PAGE = 'mainPage',
  PRODUCTS = 'products',
  PRODUCT_DETAIL = 'productDetail',
}
